import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { AccordionModule } from 'primeng/accordion';
import { ItemFeedbackFormComponent } from '../item-feedback-form/item-feedback-form.component';
import { Order, OrderMenuItem } from '../../../model/menu-data.model';
import { Feedback, FeedbackItem } from '../../../model/common.model';
import { FeedbackService } from '../../../services/feedback.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'brt-submit-order-feedback',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule, ButtonModule, TagModule, InputTextareaModule, ItemFeedbackFormComponent, AccordionModule],
  templateUrl: './submit-order-feedback.component.html',
  styleUrl: './submit-order-feedback.component.scss'
})
export class SubmitOrderFeedbackComponent {
  @Input({ required: true }) order!: Order;
  @Input() feedback?: Feedback;
  @Input() manage = false;
  @Output() updated = new EventEmitter<Feedback>();
  submitted = false;
  orderFeedback?: FeedbackItem;
  orderItems: { menuItem: OrderMenuItem, feedbackItem: FeedbackItem }[] = [];
  loading = false;

  constructor(private feedbackService: FeedbackService) { }

  async ngOnInit() {
    this.loading = true;
    const res = await this.feedbackService.mine({ ItemId: this.order.Id });
    if (res.Total > 0) {
      this.feedback = res.List[0];
      this.orderFeedback = this.feedback.Items.find(i => i.Type === "Order") as FeedbackItem;
      this.orderItems = this.order.MenuItems.map(item => {
        const feedbackItem = this.feedback.Items.find(i => i.ItemId === item.ItemId && i.Type === "MenuItem") as FeedbackItem;
        return { menuItem: item, feedbackItem: feedbackItem || { ItemId: item.ItemId, Type: "MenuItem" } };
      });
      this.submitted = true;
    } else {
      this.orderFeedback = { ItemId: this.order.Id, Type: "Order" };
      this.order.MenuItems.forEach(item => {
        this.orderItems.push({ menuItem: item, feedbackItem: { ItemId: item.ItemId, Type: "MenuItem" } });
      });
    }
    this.loading = false;
  }

  async submitFeedback() {
    if (!this.feedback) this.feedback = {};

    this.feedback.Items = [this.orderFeedback, ...this.orderItems.map(i => i.feedbackItem).filter(i => i.Rating > 0)];
    this.feedback = await this.feedbackService.submitFeedback(this.feedback);
    this.submitted = true;
    this.updated.emit(this.feedback);
  }

  async save() {
    this.feedback.Items = [this.orderFeedback, ...this.orderItems.map(i => i.feedbackItem).filter(i => i.Rating > 0)];
    this.feedback = await this.feedbackService.save(this.feedback);
    this.updated.emit(this.feedback);
  }
}
